import { initializeApollo } from '@jusbrasil-web/shared-apollo-client'

import { APOLLO_INTERNAL_CSR_URI, APOLLO_INTERNAL_STATE } from '../constants'
import { AppPropsWithApollo, WithApollo } from '../types'

const noop = () => undefined

export const withApollo: WithApollo = (ctx, options = {}) => {
  const { initialState, clientOverrides = {} } = options
  const client = initializeApollo(initialState, ctx.req, clientOverrides)

  let usageWarningTimer: ReturnType<typeof setTimeout> | undefined

  if (process.env.NODE_ENV !== 'production') {
    const error = new Error(
      '[core-apollo] withApollo() was called but withApolloProps() was never invoked. ' +
        'This means the Apollo cache state will not be passed to the client, causing hydration issues. ' +
        'Make sure to spread ...withApolloProps() in your getServerSideProps return value.'
    )
    usageWarningTimer = setTimeout(() => {
      console.warn(error)
    }, 5_000)
    usageWarningTimer.unref?.()
  }

  return {
    client,
    withApolloProps() {
      clearTimeout(usageWarningTimer)
      const clientCacheExtract = client.cache.extract()
      client
        .clearStore()
        .then(noop)
        .catch((rejectionReason) =>
          console.error(
            'Error fire-and-forget clearing Apollo client store after request',
            rejectionReason
          )
        )

      const props: AppPropsWithApollo = {
        [APOLLO_INTERNAL_STATE]: clientCacheExtract,
      }

      if (clientOverrides.csrUri) {
        props[APOLLO_INTERNAL_CSR_URI] = clientOverrides.csrUri
      }

      return props
    },
  }
}
